export default {"src":"/_next/static/media/wallet.4d049b40.svg","height":18,"width":20};